export const GET_WORKSTATION_POSITIONS_STATUS = 'GET_WORKSTATION_POSITIONS_STATUS';
export const GET_WORKSTATION_POSITIONS_STATUS_SUCCESS = 'GET_WORKSTATION_POSITIONS_STATUS_SUCCESS';
export const GET_WORKSTATION_POSITIONS_STATUS_ERROR = 'GET_WORKSTATION_POSITIONS_STATUS_ERROR';
